"use client";
import * as s from "react";
import * as h from "react-dom";
import { i as g } from "./floating-ui.utils.dom-DmuU7Umk.mjs";
import { u as j } from "./useId-CFOlRH4L.mjs";
import { u as F } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { v as L } from "./visuallyHidden-DPuANzJJ.mjs";
import { e as O, F as P, i as x, g as A, a as q, c as D, d as G } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { j as R } from "./jsx-runtime-CJ-St4mQ.mjs";
const b = /* @__PURE__ */ s.createContext(null);
process.env.NODE_ENV !== "production" && (b.displayName = "PortalContext");
const k = () => s.useContext(b), C = D("portal");
function w(v = {}) {
  const {
    id: c,
    root: m
  } = v, u = j(), r = k(), [e, t] = s.useState(null), a = s.useRef(null);
  return F(() => () => {
    e == null || e.remove(), queueMicrotask(() => {
      a.current = null;
    });
  }, [e]), F(() => {
    if (!u || a.current)
      return;
    const o = c ? document.getElementById(c) : null;
    if (!o)
      return;
    const n = document.createElement("div");
    n.id = u, n.setAttribute(C, ""), o.appendChild(n), a.current = n, t(n);
  }, [c, u]), F(() => {
    if (m === null || !u || a.current)
      return;
    let o = m || (r == null ? void 0 : r.portalNode);
    o && !g(o) && (o = o.current), o = o || document.body;
    let n = null;
    c && (n = document.createElement("div"), n.id = c, o.appendChild(n));
    const d = document.createElement("div");
    d.id = u, d.setAttribute(C, ""), o = n || o, o.appendChild(d), a.current = d, t(d);
  }, [c, m, u, r]), e;
}
function z(v) {
  const {
    children: c,
    id: m,
    root: u,
    preserveTabOrder: r = !0
  } = v, e = w({
    id: m,
    root: u
  }), [t, a] = s.useState(null), o = s.useRef(null), n = s.useRef(null), d = s.useRef(null), y = s.useRef(null), I = t == null ? void 0 : t.modal, N = t == null ? void 0 : t.open, E = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!t && // Guards are only for non-modal focus management.
    !t.modal && // Don't render if unmount is transitioning.
    t.open && r && !!(u || e)
  );
  return s.useEffect(() => {
    if (!e || !r || I)
      return;
    function i(l) {
      e && x(l) && (l.type === "focusin" ? O : G)(e);
    }
    return e.addEventListener("focusin", i, !0), e.addEventListener("focusout", i, !0), () => {
      e.removeEventListener("focusin", i, !0), e.removeEventListener("focusout", i, !0);
    };
  }, [e, r, I]), s.useEffect(() => {
    e && (N || O(e));
  }, [N, e]), /* @__PURE__ */ R.jsxs(b.Provider, {
    value: s.useMemo(() => ({
      preserveTabOrder: r,
      beforeOutsideRef: o,
      afterOutsideRef: n,
      beforeInsideRef: d,
      afterInsideRef: y,
      portalNode: e,
      setFocusManagerState: a
    }), [r, e]),
    children: [E && e && /* @__PURE__ */ R.jsx(P, {
      "data-type": "outside",
      ref: o,
      onFocus: (i) => {
        var l;
        if (x(i, e))
          (l = d.current) == null || l.focus();
        else {
          const p = t ? t.domReference : null, f = A(p);
          f == null || f.focus();
        }
      }
    }), E && e && /* @__PURE__ */ R.jsx("span", {
      "aria-owns": e.id,
      style: L
    }), e && /* @__PURE__ */ h.createPortal(c, e), E && e && /* @__PURE__ */ R.jsx(P, {
      "data-type": "outside",
      ref: n,
      onFocus: (i) => {
        var l;
        if (x(i, e))
          (l = y.current) == null || l.focus();
        else {
          const p = t ? t.domReference : null, f = q(p);
          f == null || f.focus(), t != null && t.closeOnFocusOut && (t == null || t.onOpenChange(!1, i.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
export {
  z as F,
  k as u
};
